import { Interventielaag } from '@cumlaude/metadata';
import { BasicFilterExpression, CompoundFilterExpression } from './data.service';
import { generateCssClassForString, isHuidigeMaand, today } from '@cumlaude/shared-utils';

export const interventielaagDetails = {
	[Interventielaag.GOEDE_AANWEZIGHEID]: '≥ 95% aanwezig',
	[Interventielaag.BEGINNEND_VERZUIM]: '90% - 95% aanwezig',
	[Interventielaag.AANHOUDEND_VERZUIM]: '≤ 90% aanwezig',
};

export function interventielaagForPerc(perc: number) {
	if (perc >= 0.95) return Interventielaag.GOEDE_AANWEZIGHEID;
	else if (perc <= 0.9) return Interventielaag.AANHOUDEND_VERZUIM;
	return Interventielaag.BEGINNEND_VERZUIM;
}

export type JaarMaand = { nr_maand: string; nr_jaar: string; voorlopig: boolean };

export function getAfgeslotenMaandenFilter() {
	const nr_jaar_huidig = today().getFullYear();
	const nr_maand_huidig = today().getMonth() + 1;
	return new CompoundFilterExpression(
		[
			new BasicFilterExpression(['aw_nr_jaar'], nr_jaar_huidig, '<'),
			new CompoundFilterExpression(
				[new BasicFilterExpression(['aw_nr_jaar'], nr_jaar_huidig, '='), new BasicFilterExpression(['aw_nr_maand'], nr_maand_huidig, '<=')],
				'and'
			),
		],
		'or'
	);
}

export function getSchoolaanwezigheidClass(schooljaar: string | undefined, nr_maand: string, laag: Interventielaag) {
	const base = generateCssClassForString(laag);
	const maybeStriped = isHuidigeMaand(schooljaar, nr_maand) ? ' striped-m' : '';
	return `${base}${maybeStriped}`;
}
